export const getUserImage = (userEmail: string): string => {
	switch (userEmail) {
		case 'rostislav@easproject.com ':
			return '/img/users/ros.png';
		case 'aleksandra@easproject.com':
			return '/img/users/alex.png';
		case 'mikhail@easproject.com':
			return '/img/users/mikh.png';
		case 'peter@easproject.com':
			return '/img/users/peter.png';
		case 'teemu@easproject.com ':
			return '/img/users/teemu.png';
		case 'robert@easproject.com':
			return '/img/users/robert.png';
		case 'nikolai@easproject.com':
			return '/img/users/nick.png';
		case 'andrii@easproject.com':
			return '/img/users/andrii.png';
		case 'victoria@easproject.com':
			return '/img/users/victoria.png';
		case 'oleg.r@easproject.com':
			return '/img/users/oleg1.jpg';
		case 'alexandra@easproject.com':
			return '/img/users/sasha.png';
		default:
			return '';
	}
};
